<template>
  <div class="table-settings-modal-save">
    <div
      v-if="hasOptions"
      class="table-settings-save-options"
    >
      <template v-if="hasPresetSaveForm && !presetId">
        <MCheckbox
          v-model="saveAsPreset"
          :label-text="_getTr('save_as_preset')"
          class="table-settings-save-options__option"
        />
      </template>
      <template v-if="saveAsPreset">
        <component
          :is="presetSaveFormComponent"
          :form-errors="formErrors"
          :preset-id="presetId"
          v-bind="saveFormPayload"
          class="table-settings-save-options__option"
          @changeVal="handleSaveFormValueChanged"
        />
      </template>
    </div>
    <div class="table-settings-modal-save__buttons">
      <MButton
        :is-loading="submitIsLoading"
        @click="handleApply"
      >
        {{ _getTr('apply') }}
      </MButton>
      <MButton
        :secondary="true"
        class="table-settings-save-buttons__cancel"
        @click="handleCancel"
      >
        {{ _getTr('cancel') }}
      </MButton>
    </div>
  </div>
</template>

<script>
  import MButton from 'components/Inputs/Basic/MButton';
  import MCheckbox from 'components/Inputs/Basic/MCheckbox';

  export default {
    name: 'TableSettingsModalSave',
    components: {MCheckbox, MButton},
    props: {
      presetId: {
        type: Number,
        default: null
      },
      presetData: {
        type: Object,
        default: Object
      },
      columns: {
        type: Array,
        required: true
      },
      presetSaveFormComponent: {
        type: Object,
        default: null
      },
      presetSaveFormPayload: {
        type: Object,
        default: null
      },
      presetSaveFormHandlers: {
        type: Object,
        default: Object
      }
    },
    data () {
      return {
        submitIsLoading: false,
        saveAsPreset: false,

        formErrors: {},

        saveFormPayload: {}
      };
    },
    computed: {
      hasPresetSaveForm () {
        return Boolean(this.presetSaveFormComponent);
      },
      hasOptions () {
        return this.hasPresetSaveForm;
      },
      savePresetMethod () {
        return this.presetSaveFormHandlers.onSave;
      }
    },
    mounted () {
      if (this.presetId) {
        this.saveFormPayload = this.presetData;
        this.saveAsPreset = true;
        return;
      }
      if (this.presetSaveFormPayload) {
        this.saveFormPayload = {...this.presetSaveFormPayload};
        return;
      }
      this.saveFormPayload = this.loadFormFields();
    },
    methods: {
      handleSaveFormValueChanged ({key, value}) {
        this.saveFormPayload[key] = value;
      },
      loadFormFields () {
        if (!this.hasPresetSaveForm) {
          return {};
        }

        const formProps = this.presetSaveFormComponent.props;
        const payload = {};
        Object.keys(formProps).map(key => {
          const defaultConstructor = formProps[key].default;
          payload[key] = typeof defaultConstructor === 'function' ? defaultConstructor() : defaultConstructor;
        });
        return payload;
      },
      async handleApply () {
        if (this.saveAsPreset) {
          this.submitIsLoading = true;
          const [success, errorObject, presetId] = await this.savePresetMethod(
            this.presetId, this.saveFormPayload, this.columns);
          this.submitIsLoading = false;
          if (!success) {
            this.formErrors = errorObject || {};
            return;
          }

          return this.$emit('saveAndApplyPreset', presetId);
        }
        this.$emit('apply');
      },
      handleCancel () {
        this.$emit('cancel');
      }
    }
  };
</script>

<style>
  .table-settings-save-buttons__cancel {
    margin-left: 12px;
  }

  .table-settings-save-options {
    margin-bottom: 16px;
  }

  .table-settings-save-options > .table-settings-save-options__option ~ .table-settings-save-options__option {
    margin-top: 16px;
  }
</style>
